import React, { useState, useEffect } from "react";
import { Container, CardGroup, Card, Image, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faSolarPanel,
  faLightbulb,
} from "@fortawesome/free-solid-svg-icons";
import bulb from "../images/bulb.png";
import house from "../images/house.png";
import blocksRight from "../images/blocks-right.png";
import blocks from "../images/blocks.png";

export default function Marketplace() {
  const [listings, setListings] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL_PROD}/api/listings`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((respn) => respn.json())
      .then((resp) => {
        setListings(resp);
      })
      .catch((error) => console.log(error));
  }, []);

  return (
    <>
      <div className="banner-icons" style={{ marginTop: "12%" }}>
        {" "}
        <Image
          src={blocksRight}
          width="15%"
          style={{
            float: "left",
          }}
        />
        <Image
          src={house}
          width="15%"
          style={{
            float: "right",
          }}
        />
      </div>

      <Container
        style={{
          marginTop: "30%",
          marginBottom: "3%",
          width: "90%",
        }}
      >
        <Container style={{ textAlign: "center" }}>
          <div className="ellipse3"></div>
          <div className="ellipse2"></div>
          <h1 className="h1-colorful">
            Bloomberg Terminal for Renewables
          </h1>{" "}
          <div style={{ width: "50%", margin: "auto" }}>
            {" "}
            <p>
              The most powerful tool for financial and development professionals
              in the renewable energy market with real-time data, news, and
              analytics.
            </p>
          </div>
          <p>Supercharge your deal flow, M&A and origination.</p>
        </Container>
      </Container>

      <div className="banner-icons">
        {" "}
        <Image
          src={bulb}
          width="15%"
          style={{
            float: "left",
          }}
        />
        <Image
          src={blocks}
          width="20%"
          style={{
            float: "right",
          }}
        />
      </div>

      <Container
        style={{ textAlign: "center", marginBottom: "20%", marginTop: "5%" }}
      >
        <CardGroup
          style={{
            marginTop: "5%",
            marginBottom: "5%",
            paddingLeft: "10%",
            paddingRight: "5%",
          }}
        >
          <Card className="shadow">
            {" "}
            <Card.Body style={{ textAlign: "center", borderRadius: "10px" }}>
              <Card.Title>
                <FontAwesomeIcon icon={faChartLine}></FontAwesomeIcon> Market
                Intelligence
              </Card.Title>
              <Card.Text>
                <p>
                  Discover and track projects, development pipelines, deals,
                  suppliers, EPCs & people in the industry.
                </p>
              </Card.Text>
            </Card.Body>
          </Card>

          <Card className="shadow">
            {" "}
            <Card.Body style={{ textAlign: "center", borderRadius: "10px" }}>
              <Card.Title>
                {" "}
                <FontAwesomeIcon icon={faLightbulb}></FontAwesomeIcon> Exclusive
                Deal Flow
              </Card.Title>
              <Card.Text>
                <p>
                  Get matched to developers with projects that are still
                  private, and are looking for investors just like you.
                </p>
              </Card.Text>
            </Card.Body>
          </Card>
          <Card className="shadow">
            {" "}
            <Card.Body style={{ textAlign: "center", borderRadius: "10px" }}>
              <Card.Title>
                {" "}
                <FontAwesomeIcon icon={faSolarPanel}></FontAwesomeIcon> Contact
                Developers and Suppliers
              </Card.Title>
              <Card.Text>
                <p>
                  Directly contact vendors and projects that are pre-RFP,
                  pre-construction and in the interconnection queue.
                </p>
              </Card.Text>
            </Card.Body>
          </Card>
        </CardGroup>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            className="btn-hover color-3"
            style={{ borderRadius: "20px" }}
            href="https://forms.gle/JHb82K9MSJ3q8mJg7"
            target="_blank"
          >
            Join Waitlist
          </Button>
        </div>
        {/* <ListingCardGroup listings={listings} /> */}
      </Container>
    </>
  );
}
